export default "__VITE_ASSET__818mkb5M__"